import type { PriceResultsMoreFromSource } from '@/pages/Item/helpers/getPriceResultsMoreFromSource';

export const MORE_FROM_LIMIT = 12;

export type PriceResultsMoreFromState = {
    itemIds: number[];
    loaded: boolean;
    loading: boolean;
    sourceItemId: number;
};

export const defaultPriceResultsMoreFromSlice: PriceResultsMoreFromState = {
    itemIds: [],
    loaded: false,
    loading: false,
    sourceItemId: 0,
};

export type FetchPriceResultsMoreFromArgs = {
    excludeItemId: number;
    itemId: number;
    source: PriceResultsMoreFromSource | null;
};
